import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setPreview as setPreviewAction } from "../../Actions/commonAction";
import If from "../Common/If";
import DocViewer from "./DocViewer";

const Preview = ({ PreviewReducer: { show = false, type = "", data = "", name = null, isbase64 = false, ext = null }, setPreview }) => (
  <div>
    <Dialog fullScreen open={show} transitionDuration={{ enter: 500, exit: 500 }} onClose={() => setPreview({ show: false, type: "", data: "" })}>
      <div>
        <If condition={type === "doc"}>
          <DocViewer docUrl={data} name={name} ext={ext} isbase64={isbase64} onClose={() => setPreview({ show: false, type: "", data: "", name: null, isbase64: false, ext: null })} />
        </If>
      </div>
    </Dialog>
  </div>
);

function mapStateToProps(state) {
  return {
    PreviewReducer: state.PreviewReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setPreview: setPreviewAction }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Preview);
